import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import { ShareModal } from '../Share/ShareModal';
import { useNexaStore } from '../NexaStore';
import { useHasEvents } from '../hooks/useHasEvents';

export const ShareButton: React.FC = () => {
  const [openShareModal, setOpenShareModal] = useState(false);
  const id = useNexaStore((state) => state.id);
  const { hasEvents, isShareId } = useHasEvents();

  // Only show share button if there's a session with events AND not a share
  if (!hasEvents || isShareId) {
    return null;
  }

  return (
    <>
      <Tooltip title="Share Session">
        <Button icon={<ShareAltOutlined />} onClick={() => setOpenShareModal(true)} />
      </Tooltip>
      <ShareModal open={openShareModal} onClose={() => setOpenShareModal(false)} sessionId={id!} />
    </>
  );
};
